import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import axios from 'axios';
import {BASE_URL, validEmailRegex} from '../../utils/const';
import Container from 'reactstrap/lib/Container';
import Logo from './img/logoRms.svg';
import Label from 'reactstrap/lib/Label';
import {t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import InputText from '../../components/FormFields/InputText';
import {Toast} from '../../utils/sweetAlert';
import * as yup from 'yup';
import {useHistory} from 'react-router-dom';

const ForgotPassword = () => {
  const history = useHistory()
  const passwordScheme = yup.object().shape({
    mail: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validEmailRegex, t('message.fieldNotValid'))
      .max(50, `${t('message.max', {max: 50})}`)
      .min(3, `${t('message.min', {min: 3})}`),
  })
  const methods = useForm({
    resolver: yupResolver(passwordScheme),
  });
  const {handleSubmit, errors} = methods;

  const submitForm = (data) => {
    axios({
      method: 'POST',
      url: `${BASE_URL}/account/reset-password/init`,
      data: {email: data?.mail},
      headers: {
        Authorization: 'Bearer ',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    }).then((res) => {
      if (res?.status === 200) {
        Toast.fire({
          title: t('message.sentSuccess'),
          icon: 'success',
        });
      history.push(`/login`);
      }
    }).catch((err) => {
    })

  }

  return (
    <div className="login_wrapp">
      {/*<div className="left"></div>*/}
      <div className="right">
        <Container>
          <div className="wrapp">
            <img className="header-img" src={Logo}></img>
            <h4 className="login-title"></h4>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-4">
                  <p>{t('login.forgotPassSubTitle')}</p>
                  <Label for="mail"> {t('login.mail')}</Label>
                    <InputText
                      name={'mail'}
                      type="text"
                      id="mail"
                      className={
                        "form-control " +
                        (errors.mail !== undefined ? "error-field" : "")
                      }
                      placeholder={t("login.mailPlaceholder")}
                    />
                </Row>

                <Row className="submit-buttons-container mx-0">
                  <Col sm={12} className="text-right px-0">
                    <div className="submit d-flex justify-content-center">
                      <button className="primary">
                        {t("buttons.sendInstructions").toUpperCase()}
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ForgotPassword;